import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../../components/Footer';
import style from './style.css';
import Header from '../../components/Header';

const MainLayout = props => {
    const { children, className } = props;

    return (
        <div className={style.wrapper}>
            <div className={style.header}>
                <Header className={className} />
            </div>

            <div className={style.body}>
                <div className={className}>{children}</div>
            </div>

            <div className={style.footer}>
                <Footer className={className} />
            </div>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

MainLayout.defaultProps = {
    className: 'container',
};

export default MainLayout;
